// extracted by mini-css-extract-plugin
export default {"box":"AddFavFoodBtn_box__bLGIE","plus-mark":"AddFavFoodBtn_plus-mark__fgmYo"};